export const ActionTypes = {
  LOADING: "CHECK_AHTH_LOADING",
  ERROR: "CHECK_AUTH_ERROR",
  SUCCESS: "CHECK_AUTH_SUCCESS",

  SET_TOKEN: "SET_TOKEN",
  REMOVE_TOKEN: "REMOVE_TOKEN"
};
